module.exports = __webpack_public_path__ + "img/party_upper_2.e42dc5ca.jpg";